import { render } from "./NewTestView.vue?vue&type=template&id=2503631e&scoped=true"
import script from "./NewTestView.vue?vue&type=script&lang=js"
export * from "./NewTestView.vue?vue&type=script&lang=js"

import "./NewTestView.vue?vue&type=style&index=0&id=2503631e&scoped=true&lang=css"
import "./NewTestView.vue?vue&type=style&index=1&id=2503631e&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2503631e"]])

export default __exports__